import axios from "axios";
import { useState } from "react";
import { log } from "../../../../commonfunctions/logger";
import sortSizes from "../../../../commonfunctions/size-sorter";
import { ProductColor } from "../../../../interfaces/interfaces";
import { Branch } from "../../../../interfaces/types";
import AuthenticationHOC from "../../../AuthenticationHOC/AuthenticationHOC";
import { ColorSizeStock } from "../../interfaces";
import Button, { ButtonType } from "../../../Button/Button";

interface Props {
  generateAuthHeader: any;
  color: ProductColor;
  branch: Branch;
  onStocksLoaded?: (stocks: ColorSizeStock[]) => void;
}

const OverseaStock = (props: Props) => {
  const { generateAuthHeader, color, branch, onStocksLoaded } = props;
  const [shouldDisplayLoadingStockError, setShouldDisplayLoadingStockError] =
    useState<boolean>(false);
  const [isLoadingStock, setIsLoadingStock] = useState<boolean>(false);
  const [colorSizeStocks, setColorSizeStocks] = useState<ColorSizeStock[]>([]);

  const getStock = (color: any) => {
    setIsLoadingStock(true);
    let skus = "";

    if (color.sizes.length > 0) {
      for (let i = 0; i < color.sizes.length; i++) {
        skus += "&skus[]=" + color.sizes[i].sku;
      }
    }
    const url = `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/current_order/items/sizes_detail_by_skus?branch=${branch}&color_id=${color.id}${skus}`;
    axios
      .get(url, generateAuthHeader())
      .then((response) => {
        if (response.data.items) {
          const sortedStock = sortSizes(response.data.items);
          setColorSizeStocks(sortedStock);
          setIsLoadingStock(false);
          onStocksLoaded?.(sortedStock);
        } else {
          setIsLoadingStock(false);
          setShouldDisplayLoadingStockError(true);
        }
      })
      .catch((error) => {
        log(error, `Failed to load stock for ${url}`);
        setIsLoadingStock(false);
        setShouldDisplayLoadingStockError(true);
      });
  };

  if (!color) return <></>;

  if (onStocksLoaded) {
    if (shouldDisplayLoadingStockError) {
      return <small className="stock-error-text">Failed to load</small>;
    }
    if (colorSizeStocks.length > 0) {
      return (
        <span className="text-nowrap">
          <span className="text-uppercase">{branch}</span> Stock
        </span>
      );
    }
    return (
      <Button
        onClick={() => getStock(color)}
        isLoading={isLoadingStock}
        type={ButtonType.secondary}
        className="btn-compact"
      >
        <span>
          Check <b className="text-uppercase">{branch}</b> stock
        </span>
      </Button>
    );
  }
};

export default AuthenticationHOC(OverseaStock);
